import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { PlaceholderBanner } from "@/components/common/PlaceholderBanner";
import { Link } from "react-router-dom";

export default function LearningPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/learning").then(r => setRows(r.data)); }, []);

  return (
    <div data-testid={TID.learningPage} className="space-y-6 animate-fade-in-up">
      <header className="flex items-end justify-between border-b border-border pb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-altara-teal font-semibold">Learning</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight text-altara-ink mt-1">Consumer education records</h1>
          <p className="text-sm text-muted-foreground mt-1">MOCKED integration with Altara Consumer Education. Do not rebuild the education platform here — this tab is for consumption only.</p>
        </div>
        <div className="font-mono text-[10px] text-muted-foreground">{rows.length} records</div>
      </header>

      <PlaceholderBanner
        title="Integration placeholder · MOCKED"
        message="This page is populated from the Altara Consumer Education adapter running in MOCKED mode. When you wire the real Cerebro / Moodle / SCORM integration, the same table will render live records. Nothing about the domain model changes."
      />

      <div className="border border-slate-200 rounded-sm overflow-hidden bg-white">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.15em] text-slate-500">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Consumer</th>
              <th className="text-left px-4 py-2 font-medium">Course</th>
              <th className="text-left px-4 py-2 font-medium">Provider</th>
              <th className="text-left px-4 py-2 font-medium">Status</th>
              <th className="text-left px-4 py-2 font-medium">Completion</th>
              <th className="text-left px-4 py-2 font-medium">Completed</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.learning_id} className="border-t border-slate-100 hover:bg-slate-50/60">
                <td className="px-4 py-2">
                  <Link to={`/consumers/${r.consumer_id}`} className="font-mono text-[10px] text-altara-teal hover:text-altara-deep">{r.consumer_id.slice(0, 12)}…</Link>
                </td>
                <td className="px-4 py-2">
                  <div className="font-medium text-slate-800">{r.course_title}</div>
                  <div className="text-[10px] font-mono text-slate-500">{r.course_code}</div>
                </td>
                <td className="px-4 py-2 text-slate-600">{r.provider}</td>
                <td className="px-4 py-2 uppercase text-[10px] tracking-widest">{r.status}</td>
                <td className="px-4 py-2 font-mono tabular-nums">{r.completion_pct}%</td>
                <td className="px-4 py-2 font-mono text-[10px] text-slate-500">{r.completed_at ? new Date(r.completed_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No learning records.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
